import { render } from "./requestForm.vue?vue&type=template&id=619ae554&scoped=true"
import script from "./requestForm.vue?vue&type=script&lang=js"
export * from "./requestForm.vue?vue&type=script&lang=js"

import "./requestForm.vue?vue&type=style&index=0&id=619ae554&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619ae554"]])

export default __exports__